<template>
  <div v-if="tpdata" class="tp-info-page">
    <div class="tp-info-page-body">
      <div class="tp-info-page-body-head flex-center" :style="{backgroundImage: 'url(' + tpdata.backgroundImage + ')'}">
        <div class="tp-info-page-body-head-box flex-center cursor" @click="toList">更多专题活动</div>
        <div class="tp-info-page-body-head-text-body flex-column-center">
          <p v-if="tpdata.title" :style="{color: tpdata.titleColor}" class="title text-line-2">{{ tpdata.title }}</p>
          <p v-if="tpdata.description" :style="{color: tpdata.descriptionColor}" class="info">{{ tpdata.description }}</p>
        </div>
      </div>
      <div class="tp-info-page-body-chaplist">
        <div v-for="(item, index) in tpdata.chapterList" :key="index" class="tp-info-page-body-chaplist-item" :style="backgroundImg(item)">
          <div v-if="item.style == 1" :style="{background: gradient(item)}" class="tp-info-page-body-chaplist-item-001">
            <div class="tp-info-page-body-chaplist-item-head">
              <p class="tit text-line-2">{{ item.title }}</p>
              <p class="desc text-line-4">{{ item.description }}</p>
            </div>
            <div class="tp-info-page-body-chaplist-item-list flex">
              <div v-for="(s, i) in item.itemList" :key="s.id" class="tp-info-page-body-chaplist-item-list-item cursor" :class="i >= 5?'display-none':''" @click="toDetail(s)">
                <div v-if="i < 5">
                  <el-image class="cover transition" :src="'https://img.libraryplus.bjadks.com/' + s.coverImage" fit="cover">
                    <div slot="placeholder" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                    <div slot="error" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                  </el-image>
                  <p class="name text-line-1">{{ s.name }}</p>
                  <p class="info text-line-4">{{ s.description }}</p>
                </div>
              </div>
            </div>
            <div v-if="item.itemList.length > 5" class="tp-info-page-body-chaplist-item-more flex-center cursor" @click="toMore(item)">
              <p class="font-14">查看全部</p>
            </div>
          </div>
          <div v-else-if="item.style == 2" :style="{background: gradient(item)}" class="tp-info-page-body-chaplist-item-002">
            <div class="tp-info-page-body-chaplist-item-head">
              <p class="tit">{{ item.title }}</p>
              <p class="desc">{{ item.description }}</p>
            </div>
            <div class="tp-info-page-body-chaplist-item-list flex">
              <div v-for="(s, i) in item.itemList" :key="s.id" class="tp-info-page-body-chaplist-item-list-item cursor" :class="i >= 6?'display-none':''" @click="toDetail(s)">
                <div v-if="i < 6" class="flex">
                  <el-image class="cover transition" :src="'https://img.libraryplus.bjadks.com/' + s.coverImage" fit="cover">
                    <div slot="placeholder" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                    <div slot="error" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                  </el-image>
                  <div class="flex-1">
                    <p class="name text-line-1">{{ s.name }}</p>
                    <p class="info text-line-4">{{ s.description }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.itemList.length > 6" class="tp-info-page-body-chaplist-item-more flex-center cursor" @click="toMore(item)">
              <p class="font-14">查看全部</p>
            </div>
          </div>
          <div v-else-if="item.style == 3" :style="{background: gradient(item)}" class="tp-info-page-body-chaplist-item-003">
            <div class="tp-info-page-body-chaplist-item-head">
              <p class="tit">{{ item.title }}</p>
              <p class="desc">{{ item.description }}</p>
            </div>
            <div class="tp-info-page-body-chaplist-item-list flex">
              <div v-for="(s, i) in item.itemList" :key="s.id" class="tp-info-page-body-chaplist-item-list-item cursor" :class="i >= 12?'display-none':''" @click="toDetail(s)">
                <div v-if="i < 12">
                  <el-image class="cover transition" :src="'https://img.libraryplus.bjadks.com/' + s.coverImage" fit="cover">
                    <div slot="placeholder" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                    <div slot="error" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                  </el-image>
                  <p class="name text-line-1">{{ s.name }}</p>
                </div>
              </div>
            </div>
            <div v-if="item.itemList.length > 12" class="tp-info-page-body-chaplist-item-more flex-center cursor" @click="toMore(item)">
              <p class="font-14">查看全部</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <layer1 ref="ly1" />
    <layer2 ref="ly2" />
    <layer3 ref="ly3" />
  </div>
</template>

<script>
import api from '@/api/index.js'
import { getShowPath } from '@/utils/imgpath.js'
import layer1 from './components/layer_1.vue'
import layer2 from './components/layer_2.vue'
import layer3 from './components/layer_3.vue'
export default {
  components: {
    layer1,
    layer2,
    layer3
  },
  data() {
    return {
      tpdata: null
    }
  },
  mounted() {
    this.request()
  },
  methods: {
    request() {
      api.topicList({
        ids: this.$route.query.id,
        asc: 0,
        needChapter: 1,
        field: 'publishTime',

        rangeQuery: 1,
        page: 1,
        limit: 1
      }).then(r => {
        if (r.code === 2000) {
          if (r.items.data && r.items.data.length) {
            r.items.data[0].coverImage = getShowPath('img', r.items.data[0].coverImage)
            r.items.data[0].backgroundImage = getShowPath('img', r.items.data[0].backgroundImage)
            console.log(r.items.data[0].status)
            if (r.items.data[0].status !== 1) {
              this.$notify.error('该专题已下架')
              return
            } else {
              this.tpdata = r.items.data[0]
            }
          }
        }
      })
    },
    toMore(v) {
      if (v.style === '1') {
        this.$refs.ly1.showList(v.itemList)
      } else if (v.style === '2') {
        this.$refs.ly2.showList(v.itemList)
      } else if (v.style === '3') {
        this.$refs.ly3.showList(v.itemList)
      }
    },
    toDetail(v) {
      const { type, dataId, catalogId } = v
      if (type === 4) {
        const page = this.$router.resolve({
          path: '/source',
          query: {
            cateId: catalogId,
            sourceId: dataId
          }
        })
        window.open(page.href, '_blank')
      } else {
        const page = this.$router.resolve({
          path: '/entity',
          query: {
            cateId: catalogId,
            sourceId: dataId
          }
        })
        window.open(page.href, '_blank')
      }
    },
    toList() {
      this.$router.push({
        path: '/topic'
      })
    },
    backgroundImg(val) {
      if (val.texture) {
        return { backgroundImage: 'url(' + require(`../../assets/shjk/tp-${val.texture}.png`) + ')' }
      }
      return ''
    },
    gradient(val) {
      if (val.background) {
        if (val.shadowStyle === '0') {
          return val.background
        } else if (val.shadowStyle === '1') {
          return `linear-gradient(180deg, ${val.background} 0%, ${val.background}00 100%)`
        } else if (val.shadowStyle === '2') {
          return `linear-gradient(0deg, ${val.background} 0%, ${val.background}00 100%)`
        } else if (val.shadowStyle === '3') {
          return `linear-gradient(to right, ${val.background} 0%, ${val.background}00 100%)`
        } else if (val.shadowStyle === '4') {
          return `linear-gradient(to right, ${val.background}00 0%, ${val.background} 100%)`
        } else if (val.shadowStyle === '5') {
          return `linear-gradient(to bottom right, ${val.background} 0%, ${val.background}00 100%)`
        } else if (val.shadowStyle === '6') {
          return `linear-gradient(to bottom left, ${val.background} 0%, ${val.background}00 100%)`
        } else {
          return val.background
        }
      }
      return ''
    }
  }
}
</script>

<style>

  .tp-info-page-body-head {
    height: 900px;
    position: relative;
    width: 100%;
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
  }

  .tp-info-page-body-head-box {
    position: absolute;
    top: 10px;
    left: 10px;
    background: rgba(0, 0, 0, 0.25);
    width: 100px;
    height: 30px;
    font-size: 12px;
    color: #fff;
    border-radius: 15px;
  }

  .tp-info-page-body-head-text-body .title {
    width: 1260px;
    font-size: 50px;
    line-height: 70px;
    text-align: center;
    text-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5);
    margin-bottom: 40px;
    color: #FFFFFF;
  }

  .tp-info-page-body-head-text-body .info {
    width: 820px;
    text-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5);
    line-height: 25px;
    font-size: 14px;
    color: #FFFFFF;
    background: rgba(0, 0, 0, 0.25);
    padding: 20px;
    border-radius: 10px;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .tp-info-page-body-head .img {
    width: 100%;
    height: 570px;
  }

  .tp-info-page-body-chaplist-item {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .tp-info-page-body-chaplist-item-head {
    margin: 0 auto;
    width: 1200px;
  }

  .tp-info-page-body-chaplist-item-head .tit {
    line-height: 40px;
    color: rgba(0, 0, 0, 0.75);
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .tp-info-page-body-chaplist-item-head .desc {
    color: rgba(0, 0, 0, 0.75);
    font-size: 14px;
    line-height: 25px;
    margin-bottom: 30px;
  }

  .tp-info-page-body-chaplist-item-list {
    width: 1200px;
    margin: 0 auto;
  }

  .tp-info-page-body-chaplist-item-more {
    width: 1200px;
    margin: 0 auto;
    height: 40px;
    border-radius: 5px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .tp-info-page-body-chaplist-item-more p {
    color: rgba(0, 0, 0, 0.5);
  }

  .tp-info-page-body-chaplist-item-001,
  .tp-info-page-body-chaplist-item-002,
  .tp-info-page-body-chaplist-item-003 {
    padding: 100px 0 80px;
  }

  .tp-info-page-body-chaplist-item-001 .tp-info-page-body-chaplist-item-list {
    margin-bottom: 20px;
  }

  .tp-info-page-body-chaplist-item-001 .tp-info-page-body-chaplist-item-list-item {
    width: 244px;
    margin-right: 20px;
  }

  .tp-info-page-body-chaplist-item-001 .tp-info-page-body-chaplist-item-list-item:last-child {
    margin-right: 0;
  }

  .tp-info-page-body-chaplist-item-001 .tp-info-page-body-chaplist-item-list-item .cover {
    width: 244px;
    height: 145px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .tp-info-page-body-chaplist-item-001 .tp-info-page-body-chaplist-item-list-item .name {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.75);
  }

  .tp-info-page-body-chaplist-item-001 .tp-info-page-body-chaplist-item-list-item .info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.75);
    line-height: 20px;
  }

  .tp-info-page-body-chaplist-item-002 .tp-info-page-body-chaplist-item-list {
    flex-wrap: wrap;
  }

  .tp-info-page-body-chaplist-item-002 .tp-info-page-body-chaplist-item-list-item {
    width: 590px;
    height: 150px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 15px;
  }

  .tp-info-page-body-chaplist-item-002 .tp-info-page-body-chaplist-item-list-item:nth-child(2n) {
    margin-right: 0;
  }

  .tp-info-page-body-chaplist-item-002 .tp-info-page-body-chaplist-item-list-item .cover {
    width: 180px;
    height: 120px;
    border-radius: 5px;
    flex-shrink: 0;
    margin-right: 15px;
  }

  .tp-info-page-body-chaplist-item-002 .tp-info-page-body-chaplist-item-list-item .name {
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.75);
  }

  .tp-info-page-body-chaplist-item-002 .tp-info-page-body-chaplist-item-list-item .info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.75);
    line-height: 20px;
  }

  .tp-info-page-body-chaplist-item-003 .tp-info-page-body-chaplist-item-list {
    flex-wrap: wrap;
  }

  .tp-info-page-body-chaplist-item-003 .tp-info-page-body-chaplist-item-list-item {
    width: 285px;
    height: 190px;
    margin-right: 20px;
    margin-bottom: 20px;
    position: relative;
  }

  .tp-info-page-body-chaplist-item-003 .tp-info-page-body-chaplist-item-list-item:nth-child(4n) {
    margin-right: 0;
  }

  .tp-info-page-body-chaplist-item-003 .tp-info-page-body-chaplist-item-list-item .cover {
    width: 285px;
    height: 190px;
    border-radius: 5px;
    margin-bottom: 4px;
  }

  .tp-info-page-body-chaplist-item-003 .tp-info-page-body-chaplist-item-list-item .name {
    font-size: 14px;
    line-height: 40px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    line-height: 40px;
    text-align: center;
    padding: 0 7px;
    color: #fff;
  }

  .transition {
    transition: .5s;
  }

  .transition:hover {
    transform: scale(1.06);
  }

  .display-none {
    display: none;
  }

</style>
